import { render } from "./IconBookOpenPage.vue?vue&type=template&id=1916ed48"
import script from "./IconBookOpenPage.vue?vue&type=script&lang=js"
export * from "./IconBookOpenPage.vue?vue&type=script&lang=js"
script.render = render

export default script